// Single-field check. The "auto / blank" sentinel (empty string / null /
// 0) is always valid — the dialog sends it when the input is empty and the
// public site falls back to fluid sizing. Anything else must be a finite,
// non-negative integer inside the allow-list range. Returns a localized
// message or null.
export function validateDimension(value, { min, max, label }) {
  if (value === '' || value === null || value === undefined) return null
  const n = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(n)) return `${label} は数値で入力してください`
  if (n === 0) return null
  if (n < 0) return `${label} は 0 以上の値で指定してください`
  if (n < min) return `${label} は ${min}px 以上で指定してください`
  if (n > max) return `${label} は ${max}px 以下で指定してください`
  return null
}

// Composite check for the width + height pair against an AllowList instance.
// Returns `{ width: msg|null, height: msg|null }` so the caller can decorate
// each field individually.
export function validateDimensions({ width, height }, allowList) {
  return {
    width: validateDimension(width, {
      min: allowList.minWidth,
      max: allowList.maxWidth,
      label: '幅',
    }),
    height: validateDimension(height, {
      min: allowList.minHeight,
      max: allowList.maxHeight,
      label: '高さ',
    }),
  }
}

// Async-validator dimension messages look like
// "width 30 is below min_width 50" or "height 9999 exceeds max_height 2000".
// The sync per-field UI shows the same constraint in Japanese, so we strip
// the redundant English line from the summary panel to avoid two error
// messages for one mistake.
export const DIMENSION_ERROR_REGEX = /^(width|height)\s+-?\d+\s+(is below|exceeds)\s+(min|max)_(width|height)/

export function filterDimensionErrors(asyncErrors) {
  return (asyncErrors || []).filter(msg => !DIMENSION_ERROR_REGEX.test(msg))
}

// Submit-gate predicate. Collects every condition that would make insertion
// unsafe so the render path can just read a single boolean.
export function canSubmit({ html, fieldErrors, summaryErrors, isValidating }) {
  if (isValidating) return false
  if (!html || html.trim().length === 0) return false
  if (fieldErrors && (fieldErrors.width || fieldErrors.height)) return false
  if (summaryErrors && summaryErrors.length > 0) return false
  return true
}
